export default {
  COMMON: {
    REJECT: 'Reject',
    CONTINUE: 'Continue',
    SIGN: 'Sign',
    LOADING: 'Loading...',
    VERIFY: 'Verify',
    CANCEL: 'Cancel',
    VIEW: 'View',
    DOWNLOAD: 'Download',
    ATTACHMENTS: 'Attachments',
    DOCUMENTS: 'Documents',
    READ: 'Read',
    CHECKED: 'Checked',
  },

  APPROVER_INBOX: {
    TITLE: 'Order Inbox',
    SUBTITLE: 'Select the orders you want to sign.',
    SELECT_ALL: 'Select all orders',
    SELECT_ALL_ORDERS: 'Select all orders',
    LOADING: 'Loading inbox...',
    EMPTY: 'No orders found.',
    EMPTY_TITLE: 'No sign orders for approval',
    EMPTY_SUBTITLE: 'There are currently no sign orders awaiting your approval.',
    ERROR_LOAD: 'Failed to load inbox.',
    UNKNOWN_SENDER: 'Unknown sender',
    SENT_YOU_FILES: 'sent you documents to sign',
    VIEW_FILE: 'View File',
    REJECT_ORDER: 'Reject Order',
    REVIEW_SELECTED: 'Review Selected ({{count}})',
    EXPAND: 'Expand',
    COLLAPSE: 'Collapse',
    CREATED: 'Created',
    ONE_FILE: '1 file',
    MANY_FILES: 'documents',
    MORE: 'More',
    COPY_HASHSUM: 'Copy Hashsum',
  },
  APPROVER_SIGN: {
    TITLE: 'Agreement documents for signature',
    INSTRUCTION: 'I have read and accept the contents of the following agreement documents. Once I have signed the agreements, they will be bound by me.',
  },
  TAB_DETECTION: {
    TITLE: 'This URL link is already in use in another tab.',
    SUBTITLE: 'Close the other tab, and then reload this page.',
  },

  FORMS: {
    NO_COUNTRIES_FOUND: 'No countries found',
    NO_RESULTS_FOUND: 'No results found',
    CHOOSE_FILES: 'Choose files',
    NO_FILE_CHOSEN: 'No file chosen',
    SELECT_AN_OPTION: 'Select an option',
    SEARCH: 'Search...',
    ERRORS: {
      REQUIRED: 'This field is required',
      EMAIL: 'Please enter a valid email address',
      MIN_LENGTH: 'Minimum length is {{requiredLength}} characters',
      MAX_LENGTH: 'Maximum length is {{requiredLength}} characters',
      INVALID: 'Invalid value',
      ONLY_NUMBERS: 'Only numbers are allowed',
      FILE_TYPE: 'File must be jpeg, jpg, bmp, gif or pdf',
      CPR_ONLY_DIGITS: 'CPR must contain only digits',
      CPR_LENGTH: 'CPR must be exactly 10 digits',
      CPR_INVALID: 'CPR number is not valid',
      BANK_ACCOUNT_REG_ONLY_NUMERIC: 'Only numbers are allowed',
      BANK_ACCOUNT_REG_FOUR_DIGITS: 'Bank account registration number must be exactly 4 digits',
      CVR_ONLY_NUMERIC: 'Only numbers are allowed',
      CVR_EIGHT_DIGITS: 'CVR must be exactly 8 digits',
    },
  },

  CALENDAR: {
    DAYS: {
      SUN: 'Sun',
      MON: 'Mon',
      TUE: 'Tue',
      WED: 'Wed',
      THU: 'Thu',
      FRI: 'Fri',
      SAT: 'Sat',
    },
    MONTHS: {
      JANUARY: 'January',
      FEBRUARY: 'February',
      MARCH: 'March',
      APRIL: 'April',
      MAY: 'May',
      JUNE: 'June',
      JULY: 'July',
      AUGUST: 'August',
      SEPTEMBER: 'September',
      OCTOBER: 'October',
      NOVEMBER: 'November',
      DECEMBER: 'December',
    },
  },

  SIGNATURE: {
    CLEAR_SIGNATURE: 'Clear Signature',
    YOUR_SIGNATURE: 'Your Signature',
    AGREEMENT_DOCUMENT_TITLE: 'Agreement document for signature',
    AGREEMENT_DOCUMENT_DESCRIPTION: 'By signing the agreement, I indicate that I have read and accepted the contents of the following agreement document. My signature is binding.',
    FORM_DESCRIPTION: 'By signing the form, I indicate that I have read and accepted the contents of the following form. My signature is binding.',
    SIGN_HERE: 'Sign here',
  },

  STEPS: {
    LOGIN_SHARED_SECRET: 'Login with agreed code',
    LOGIN_OTP: 'Login with OTP',
    LOGIN_EID: 'Login with eID',
    LOGIN_MITID: 'Login with MitID',
    REVIEW_FILES: 'Review Files',
    REVIEW_DOCUMENTS: 'Read Documents',
    REVIEW_FORMS: 'Read Forms',
    ORDER_QUESTIONS: 'Order Questions',
    SIGN: 'Sign Document',
    SIGN_FORM: 'Form for signature',
    RECEIPT: 'Receipt',
    DOWNLOAD: 'Download',
    CPR: 'CPR Verification',
    FILE: 'File Upload',
    FILES: 'Secure Delivery',
    APPROVER_REVIEW_FILES: 'Order Inbox',
    APPROVER_SIGN: 'Agreement documents for signature',
  },
  LOGIN_OTP: {
    INSTRUCTION: 'Please enter the SMS code you received on your phone. The code has been sent to phone no. {{ phoneNumber }}.',
    OTP_CODE: 'OTP Code',
    OTP_EXPIRED: 'The OTP code has expired. Please request a new one.',
    RESEND_OTP: 'Resend OTP',
    RESEND_OTP_IN: 'Resend OTP in',
    OTP_PHONE_INSTRUCTION: 'Please enter the 6-digit code sent to your Phone.',
  },
  LOGIN_SHARED_SECRET: {
    INSTRUCTION: 'To verify your identity and gain access to your documents, please enter the agreed code you received from {{ senderName }}.',
    SHARED_SECRET: 'Agreed code',
    SHARED_SECRET_ERROR: 'The agreed code does not match',
    SHARED_SECRET_REQRUIRED: 'The agreed code is required',
  },

  LOGIN_EID: {
    POPUP_ALERT: 'Please disable your popup blocker and try again.',
    ORIGIN_MISMATCH: 'Security warning: Identity provider origin mismatch. Please try again.',
    SUCCESS: 'You have successfully logged in.',
    AUTHENTICATED: 'Authentication successful.',
    ERROR: 'Login failed. Please try again.',
    INSTRUCTION: 'To securely access and sign your documents, please log in using your eID. Choose a login method below to continue.',
    SINGLE_PROVIDER_INSTRUCTION: 'To securely access and sign your documents you must log in to continue.',
    FORM_INSTRUCTION: 'To securely access and sign your form, please log in using your eID. Choose a login method below to continue.',
    FORM_SINGLE_PROVIDER_INSTRUCTION: 'To securely access and sign your form you must log in to continue.',
    CPR_INSTRUCTION: 'Please log in with your MitID/eID to verify your identity. Choose a login method below to continue.',
    CPR_SINGLE_PROVIDER_INSTRUCTION: 'Please log in with your MitID/eID to verify your identity.',
    PROVIDERS: {
      mitid: 'Log in with MitID',
      'mitid-business': 'Log in with MitID Business',
      bankid_no: 'Log in with Norwegian BankID',
      swedish_bank_id: 'Log in with Swedish BankID',
      default: 'Log in with {{name}}',
    },
    MITID_BUSINESS_SUBTITLE: 'Can be used if your company/association has joined MitID Business',
  },

  REVIEW_FILES: {
    INSTRUCTION: 'Please retrieve or open all attachments.\nOnce everything has been retrieved or opened, the sender will receive a notification\nOnce all attachments have been retrieved or opened, you can proceed to your receipt',
    SHOW_ALL_SIGNERS: 'Signer Status',
    ATTACHMENTS: 'Attachments',
    DESCRIPTION: 'See which people have signed and which are still missing.',
    NO_SIGNERS_FOUND: 'No signers found',
    FILES_LEFT: 'You need to read the remaining {{count}}, document(s).',
    FILES_READ_ALL: 'You have read all the documents. You can now proceed to the signature.',
    FORM_FILES_LEFT: 'You need to read the remaining {{count}} form(s).',
    FORM_FILES_READ_ALL: 'You have read all the forms. You can now proceed to the signature.',
    GO_TO_RECEIPT: 'Go to receipt',
    CONTINUE: 'Continue',
    FILES: 'Documents',
  },

  REVIEW_DOCUMENTS: {
    INSTRUCTION: 'Please open and read all documents and any attachments below.',
    FORM_INSTRUCTION: 'Please open and read all forms and any attachments below.',
    FILES: 'Documents',
    FORM_FILES_ONE: 'Form',
    FORM_FILES_MANY: 'Forms',
    SHOW_ALL_SIGNERS: 'Signer Status',
    ATTACHMENTS: 'Attachments',
    DESCRIPTION: 'See which people have signed and which are still missing.',
    NO_SIGNERS_FOUND: 'No signers found',
  },

  SIGN_DOCUMENT: {
    INSTRUCTION: 'Please open and read all documents and any attachments below.',
  },

  ORDER_QUESTIONS: {
    INSTRUCTION: 'Please fill in the fields below.',
    LOADING: 'Loading questions...',
    SAVING: 'Saving...',
    REQUIRED_FIELDS_WARNING: 'required questions are not answered',
    GOTO_FIRST_UNANSWERED: 'Go to first',
    INPUTS_NOT_EQUAL: 'The inputs are not equal',
    ENTER_FIELD_PLACEHOLDER: 'Enter {{field}}',
    ENTER_ZIP_CODE_PLACEHOLDER: 'Enter zip code',
    ENTER_EMAIL_PLACEHOLDER: 'Enter email address',
    ENTER_VALUE_PLACEHOLDER: 'Enter value',
    YES: 'Yes',
    NO: 'No',
    ERRORS: {
      REQUIRED: 'This field is required.',
      EMAIL: 'Enter a valid email address.',
      CPR: 'Enter a valid CPR number.',
      CVR_ONLY_NUMERIC: 'Only numbers are allowed.',
      CVR_EIGHT_DIGITS: 'CVR must be exactly 8 digits.',
      BANK_REGISTRATION_NUMBER_ONLY_NUMERIC: 'Only numbers are allowed.',
      BANK_REGISTRATION_NUMBER_FOUR_DIGITS: 'Bank registration number must be exactly 4 digits.',
      PATTERN: 'Invalid format.',
      VALUE_NOT_ALLOWED: 'This value cannot be used. Please enter a different one.',
      BACKEND_INVALID: 'This value could not be saved. Please try again.',
      FILE_TYPE: 'This file type is not allowed.',
      INVALID: 'Invalid value.',
    },
  },

  RECEIPT: {
    SUCCESS_HEADING: 'Your signature successfully completed',
    FILES_ORDER_SUCCESS_HEADING: 'Your files are retrieved',
    FILES_ORDER_SUCCESS_MESSAGE: 'An email has been sent to',
    SUCCESS_MESSAGE: 'A receipt confirming your signature has been sent to',
    SUCCESS_COMPLETION: 'When everyone has signed, you will receive an email with a link to the signed document',
    SUCCESS_COMPLETION_SINGLE_SIGNER: 'An email with a link to the signed document(s) has been sent to your email',
    FORM_SUCCESS_COMPLETION: 'When everyone has signed, you will receive an email with a link to the signed form',
    FORM_SUCCESS_COMPLETION_SINGLE_SIGNER: 'An email with a link to the signed form has been sent to your email',
    REFERENCE_ID: 'Reference ID',
    LOGGED_OUT_MESSAGE: 'You have automatically been logged out, and you can now close this window',
    ALL_SIGNERS: 'All Signers',
    ALL_SIGNERS_SINGLE_SIGNER: 'Signer',
    DOWNLOAD_MESSAGE: 'Please notice, that you have 90 days to download your copy of the agreement document. All you need to do, is follow the link from the mail, we have sent you.',
    FORM_DOWNLOAD_MESSAGE: 'Please notice, that you have 90 days to download your copy of the form. All you need to do, is follow the link from the mail, we have sent you.',
    FILES_ORDER_DOWNLOAD_MESSAGE: ', containing a receipt and a link to your files.\nPlease note that you have 90 days to download your copy of the content. All you need to do is follow the link in the email that was sent to you.',
    FILES_ORDER_REJECTED_HEADING: 'The order has been canceled',
    FILES_ORDER_REJECTED_MESSAGE: 'A notification has been sent to the sender.',
    REJECTED_BY_OWNER_TITLE: 'Order Canceled by Owner',
    REJECTED_BY_OWNER_MESSAGE: 'This order has been canceled by the owner.',
    REJECTED_BY_SIGNER_TITLE: 'Order Canceled - Signature Declined',
    REJECTED_BY_SIGNER_MESSAGE: 'This order has been canceled because one of the signers declined to sign.',
    NO_SIGNATURE_REQUIRED_HEADING: 'Success',
    NO_SIGNATURE_REQUIRED_REJECTED_HEADING: 'The order has been canceled',
    NO_SIGNATURE_REQUIRED_MESSAGE: 'An email has been sent to',
    NO_SIGNATURE_REQUIRED_REJECTED_MESSAGE: 'A notification has been sent to the sender.',
    NO_SIGNATURE_REQUIRED_MESSAGE_SUFFIX: ', it contains a receipt and a link to the appointment document. You have 90 days to retrieve your contract copy by following the link in the email.',
  },

  STATUS: {
    SIGNED: 'Signed',
    RECEIVED: 'Received',
    PENDING: 'Pending',
    REJECTED: 'Rejected',
    LOCKED: 'Locked',
  },

  NOT_FOUND: {
    TITLE: 'Page not found',
    DESCRIPTION: 'The page you are looking for does not exist, or the signature link is invalid.',
  },

  NO_SUCH_APPROVER: {
    TITLE: 'Internal signer not recognized',
    DESCRIPTION: 'No internal signers were found matching the MitId used.',
  },

  NO_ACCESS_CPR: {
    TITLE: 'CPR check could not be completed',
    DESCRIPTION: 'The MitID used does not match the CPR number to be checked. Please contact {{senderName}} and provide reference no. {{referenceId}}.',
  },

  ARCHIVED: {
    TITLE: 'The sign order is not accessible',
    DESCRIPTION: 'The sign order you are trying to access is unfortunately no longer accessible. The sign order and its related documents are deleted 90 days after the last person has signed.',
  },

  ALREADY_SIGNED: {
    TITLE: 'Already signed',
    DESCRIPTION: 'This signing order has already been signed.',
  },

  CPR_ALREADY_SIGNED: {
    TITLE: 'CPR order already signed',
    DESCRIPTION: 'This CPR signing order has already been completed.',
  },

  VERIFY_ERROR: {
    TITLE: 'Verification failed',
    DESCRIPTION: 'The identity used to sign does not match the one required for this order.',
  },

  ORDER_MISMATCH: {
    TITLE: 'Order mismatch',
    DESCRIPTION: 'The signing order does not match the current session. Please close other tabs and try again.',
  },

  PSEUDONYM_DISALLOWED: {
    TITLE: 'Pseudonym users not allowed',
    DESCRIPTION: 'The customer does not allow signing with a pseudonym identity.',
  },

  EXPIRED: {
    TITLE: 'The sign order has expired',
    DESCRIPTION: 'The sender of this signing order - {{documentReference}} - has set a deadline for when the signing order can be signed. This deadline has now expired.',
    SUB_DESCRIPTION: 'Contact the sender {{senderName}} if you have any questions or believe an error has occurred.',
    MORE_INFO: 'Click here for more information',
    INFO_TITLE: 'Why is there a deadline?',
    INFO: 'All signing orders have a deadline. This allows the sender to ensure the signing order is signed within their chosen timeframe.',
    SUB_TITLE: 'What do I do now?',
    SUB_INFO: 'The sender has been notified that one or more parties have not signed within the deadline. You can either wait for the sender to contact you, or reach out to the sender yourself.',
  },

  STEP_LOCKED: {
    TITLE: 'This step is currently locked',
    DESCRIPTION: 'This signing step is locked and cannot be completed at this time. Please contact the sender for more information.',
  },

  UNEXPECTED: {
    TITLE: 'An unexpected error occurred',
    DESCRIPTION: 'An unexpected error occurred while processing your request. Please try again later.',
  },

  STEP_NOT_AVAILABLE: {
    TITLE: 'This step is not available yet',
    DESCRIPTION: 'This signing step is not available yet. Please wait for the previous step to be completed before proceeding.',
  },

  UNAUTHORIZED: {
    TITLE: 'An error occurred',
    DESCRIPTION: 'We could not verify the signing session. Please try again using the link you received or contact the sender.',
  },

  ERRORS: {
    UNAUTHORIZED: 'You are not authorized to access this resource',
    BAD_REQUEST: 'Invalid request.',
    FORBIDDEN: 'Access to this resource is forbidden',
    NOT_FOUND: 'The requested resource could not be found',
    SERVER_ERROR: 'An error occurred on the server. Please try again later',
    UNKNOWN_ERROR: 'An unexpected error occurred. Please try again',
    SESSION_EXPIRED: 'Your session has expired. You are being redirected to login.',
  },

  RECEIPT_CPR: {
    SUCCESS_HEADING: 'Your identification has now been confirmed.',
    SUCCESS_MESSAGE: "We've sent a receipt for your CPR check to",
    REJECTED_HEADING: 'The signing has been rejected',
    REJECTED_MESSAGE: 'A notification has been sent to',
  },

  CPR_CHECK: {
    INSTRUCTION: 'Please enter your CPR-Number',
    CPR_NUMBER: 'CPR Number',
    CPR_NUMBER_PLACEHOLDER: 'Enter your social security number',
    HEALTH_INSURANCE_CARD: 'Upload a photo of your health insurance card',
    PHOTO_ID: "Upload a copy of photo ID - eg passport or driver's license",
    FILE_HINT: "Supported formats: 'png', 'jpg', 'bmp'. Max file size: 10 MB.",
    PROTECTED_CPR_PHOTO_ID_REQUIRED: 'Since you have name and address protection, we cannot verify your information. Please fill out the steps below.',
  },

  REJECT_MODAL: {
    TITLE: 'Do you want to reject this order?',
    REASON_PLACEHOLDER: 'Write your reason for rejection',
    CONFIRM: 'Confirm Rejection',
  },

  DOWNLOAD_STEP: {
    HEADING: 'Download your documents',
    DESCRIPTION: 'You can now download a copy of your signed documents. The documents are available for 90 days from the date they were signed. Click the download button to save them locally on your computer.',
    DOWNLOAD_BUTTON: 'Download Copy',
    LOGOUT_BUTTON: 'Logout',
    LOGGED_OUT_HEADING: "You've been logged out",
    LOGGED_OUT_DESCRIPTION: 'Thank you for using Esignatur. We look forward to seeing you again.',
  },

  LOGOUT_MODAL: {
    TITLE: 'Log out?',
    DESCRIPTION: 'Are you sure you want to log out? Any unsaved changes will be lost.',
    CONFIRM: 'Log out',
  },

  REJECTION_SUCCESS_MODAL: {
    TITLE: 'Order rejected successfully',
    DESCRIPTION: 'This order has been rejected',
    CONTINUE: 'Continue',
  },

  APPROVER_RECEIPT: {
    SUCCESS_HEADING: 'Your signings successfully completed.',
    SUCCESS_MESSAGE: 'You have been logged out automatically and can now close the window.',
  },

  SUPPORT: {
    CONTACT: 'Contact us via email:',
  },
};
